const DeviceData = () => import('@/views/data/Data_Device');
const CameraData = () => import('@/views/data/Data_Camera');
const GatewayData = () => import('@/views/data/Data_Gateway');
const AccessPointData = () => import('@/views/data/Data_AccessPoint');
const HubData = () => import('@/views/data/Data_Hub');

export default [
  {
    path: 'data/device/:hashID',
    name: 'Device Data',
    component: DeviceData,
  },
  {
    path: 'data/camera/:hashID',
    name: 'Camera Data',
    component: CameraData,
  },
  {
    path: 'data/gateway/:hashID',
    name: 'Gateway Data',
    component: GatewayData,
  },
  {
    path: 'data/accesspoint/:hashID',
    name: 'AccessPoint Data',
    component: AccessPointData,
  },
  {
    path: 'data/hub/:hashID',
    name: 'Hub Data',
    component: HubData,
  },
  {
    path: 'data/probe/:hashID',
    name: 'Probe Data',
    component: HubData,
  },
];
